// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"4a711e69","515":"d2f696c7","591":"f6ce05a8","639":"873beee8","728":"04e23e2d","780":"5a74f49e","894":"0d66aa94"}[chunkId] + ".chunk.js";
};